module.exports = __webpack_public_path__ + "img/QA.cdd59276.png";